import { apiClient } from "@shared/api/api-client";
import type { ApiResponse } from "@shared/types/api";
import type { DoctorOnboardingState, DoctorOnboardingStepId } from "../types";

const stepEndpointMap: Record<Exclude<DoctorOnboardingStepId, "review">, string> = {
  personal: "personal",
  credentials: "credentials",
  specialties: "specialties",
  services: "services",
  availability: "availability",
  communications: "communications",
  contract: "contract",
  marketing: "marketing",
  subscription: "subscription",
};

export interface DoctorOnboardingPayload {
  markComplete?: boolean;
  [key: string]: unknown;
}

export interface CompletionPayload {
  attestation: boolean;
  notes?: string;
}

const basePath = (doctorId: string) => `/doctors/${doctorId}/onboarding`;

export const doctorOnboardingApi = {
  async getState(doctorId: string): Promise<DoctorOnboardingState> {
    const response = await apiClient.get<ApiResponse<DoctorOnboardingState>>(basePath(doctorId));
    return response.data;
  },

  async saveStep(doctorId: string, stepId: DoctorOnboardingStepId, payload: DoctorOnboardingPayload | CompletionPayload) {
    if (stepId === "review") {
      const response = await apiClient.post<ApiResponse<DoctorOnboardingState>>(`${basePath(doctorId)}/complete`, payload);
      return response.data;
    }

    const endpoint = stepEndpointMap[stepId as Exclude<DoctorOnboardingStepId, "review">];
    const response = await apiClient.patch<ApiResponse<DoctorOnboardingState>>(`${basePath(doctorId)}/${endpoint}`, payload);
    return response.data;
  },
};
